module.exports = __webpack_public_path__ + "static/media/banner.825ef310.jpg";